export default (app) => {
  app.database.on("init", ({ collection, db, memdb }) => {
    if (!memdb) return;
    collection.on("get", 1000, (query) => (query.data ? query : { ...query, data: db.dbIndex[query.id] }));
  });
};
